module.exports = __webpack_public_path__ + "static/img/blog-03.07dcb94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-03.jpg
// module id = U8Oj
// module chunks = 7